import { useEffect, useState } from "react"
import OfferBox from "../../Components/OfferBox/OfferBox"
import Header from "../../Components/Header/Header"
import Footer from "../../Components/Footer/Footer"
import ContactsBar from "../../Components/ContactsBar/ContactsBar"
import TitleBar from "../../Components/TitleBar/TitleBar"
import ServicesBar from "../../Components/ServicesBar/ServicesBar"
import Offer from "../../Models/Offer"
import API from "../../Services/API"
import "./ProfessionalOffersView.css"
import { PackageCustomerType } from "../../Enums/PackageCustomerType"

const ProfessionalOffersView = () => {
	let [wirelessOffers, setWirelessOffers] = useState<Offer[]>([])
	let [ftthOffers, setftthOffers] = useState<Offer[]>([])
	let [fttcOffers, setfttcOffers] = useState<Offer[]>([])

	useEffect(() => {
		(async () => {
			let res = await API.getOffersAsync(2, true)
			if (res.success) {
				setWirelessOffers(filterOffers(res.data, "Wireless"))
				setftthOffers(filterOffers(res.data, "FTTH"))
				setfttcOffers(filterOffers(res.data, "FTTC"))
			}
		})()
		return () => { };
	}, [])

	function filterOffers(arr: Offer[], type: string): Offer[] {
		let res: Offer[] = []
		arr.forEach(element => {
			if (element.connection_type === type) {
				res.push(element)
			}
		});
		return res
	}

	function renderFtthOffers() {
		if (ftthOffers.length > 0) {
			return <div className="enterprise-wireless-offers-view-container">
				<div className="enterprise-offers-view-title">Internet FTTH</div>
				<div className="enterprise-offers-left-container">
					<div className="enterprise-offers-view-grid">
						{ftthOffers.map(x => <OfferBox key={x.id} data={x} customerType={PackageCustomerType.Professional} />)}
					</div>
				</div>
			</div>
		}
	}

	return (
		<div>
			<Header></Header>
			<TitleBar title='Offerte per i professionisti' imageSrc='https://www.digitalreti.com/wp-content/uploads/2021/05/libero_professionista.png' customerType={PackageCustomerType.Professional}></TitleBar>
			<div className="professional-wireless-offers-view-container">
				<div className="professional-offers-view-title">Internet Wireless</div>
				<div className="professional-offers-left-container">
					<div className="professional-offers-view-grid">
						{wirelessOffers.map(x => <OfferBox key={x.id} data={x} customerType={PackageCustomerType.Professional} />)}
					</div>
				</div>
			</div>

			{renderFtthOffers()}

			<div className="professional-fttc-offers-view-container">
				<div className="professional-offers-view-title">Internet tecnologia FTTC VDSL</div>
				<div className="professional-offers-left-container">
					<div className="professional-offers-view-grid">
						{fttcOffers.map(x => <OfferBox key={x.id} data={x} customerType={PackageCustomerType.Professional} />)}
					</div>
				</div>
			</div>
			<ServicesBar></ServicesBar>
			<ContactsBar></ContactsBar>
			<Footer></Footer>
		</div>
	)
}

export default ProfessionalOffersView